import { customContextFactory } from '../../../../../../hooks/custom-context-factory';
import { useScheduleReadOnlyRequestDetails } from '../hooks/use-schedule-readonly-request-details';

type ContextType = ReturnType<typeof useScheduleReadOnlyRequestDetails>;

export const [ScheduleReadOnlyRequestDetailsContextProvider, useScheduleReadOnlyRequestDetailsContext] =
  customContextFactory<ContextType>();
